"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
//
const CustomIcons_1 = require("./CustomIcons");
// ----------------------------------------------------------------------
const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
function Chip(theme) {
    const isLight = theme.palette.mode === 'light';
    const rootStyle = (ownerState) => {
        const defaultColor = ownerState.color === 'default';
        const filledVariant = ownerState.variant === 'filled';
        const outlinedVariant = ownerState.variant === 'outlined';
        const softVariant = ownerState.variant === 'soft';
        const defaultStyle = {
            borderRadius: '8px',
            ...(defaultColor && {
                '& .MuiChip-avatar': {
                    color: theme.palette.text[isLight ? 'secondary' : 'primary'],
                    backgroundColor: (0, styles_1.alpha)(theme.palette.grey[500], 0.48),
                },
                // OUTLINED
                ...(outlinedVariant && {
                    border: `solid 1px ${(0, styles_1.alpha)(theme.palette.grey[500], 0.32)}`,
                }),
                // SOFT
                ...(softVariant && {
                    color: theme.palette.text.primary,
                    backgroundColor: (0, styles_1.alpha)(theme.palette.grey[500], 0.16),
                    '&:hover': {
                        backgroundColor: (0, styles_1.alpha)(theme.palette.grey[500], 0.32),
                    },
                }),
            }),
        };
        const colorStyle = COLORS.map(color => ({
            ...(ownerState.color === color && {
                '& .MuiChip-avatar': {
                    color: theme.palette[color].lighter,
                    backgroundColor: theme.palette[color].dark,
                },
                // FILLED
                ...(filledVariant && {
                    '& .MuiChip-deleteIcon': {
                        color: (0, styles_1.alpha)(theme.palette[color].contrastText, 0.56),
                        '&:hover': {
                            color: theme.palette[color].contrastText,
                        },
                    },
                }),
                // SOFT
                ...(softVariant && {
                    color: theme.palette[color][isLight ? 'dark' : 'light'],
                    backgroundColor: (0, styles_1.alpha)(theme.palette[color].main, 0.16),
                    fontWeight: 600,
                    '&:hover': {
                        backgroundColor: (0, styles_1.alpha)(theme.palette[color].main, 0.32),
                    },
                    '& .MuiChip-deleteIcon': {
                        color: (0, styles_1.alpha)(theme.palette[color][isLight ? 'dark' : 'light'], 0.48),
                        '&:hover': {
                            color: theme.palette[color].dark,
                        },
                    },
                }),
            }),
        }));
        return [...colorStyle, defaultStyle];
    };
    return {
        MuiChip: {
            defaultProps: {
                deleteIcon: (0, jsx_runtime_1.jsx)(CustomIcons_1.CloseIcon, {}),
            },
            styleOverrides: {
                root: ({ ownerState }) => rootStyle(ownerState),
            },
        },
    };
}
exports.default = Chip;
